<div class="resource-chart">
  <canvas
    #canvas
    role="img"
    [attr.aria-label]="label+' · 마우스를 올리면 수집 시각과 사용률을 확인할 수 있습니다'"
  ></canvas>
  <div class="chart-empty" *ngIf="empty()">
    선택 기간에 수집한 지표가 없습니다.
  </div>
</div>
